const navigateToQueryResult = (data, queryKey) => {
  const queryKeys = Array.isArray(queryKey) ? queryKey : [queryKey];

  return queryKeys.reduce((acc, key) => acc[key], data);
};

export { navigateToQueryResult };
